import {NoJobSaved} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {Box, Typography} from '@mui/material';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {FaRegStar} from 'react-icons/fa';
import { useIsLargeDevice } from '@jobseeker/lotus/hooks';

const NoJobsSaved = () => {
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  
  const isLarge = useIsLargeDevice('md');
  return (
    
    isAppIimjobs?
        <Box
          height={'80vh'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            px={{xxs: 2, md: 3}}
          >
            <Image
              src={NoJobSaved}
              alt={'NoJobSaved'}
              width={179}
              height={179}
              object-fit="contain"
            />
            <Typography
              fontSize={18}
              color="secondary.dark"
              variant="subtitle1"
              ml={0.625}
              sx={{
                lineHeight: '30px',
              }}
            >
              {'No Saved Jobs!'}&nbsp;
            </Typography>
            <Box
              display={'flex'}
              width={205}
              flexDirection={'row'}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Typography
                component={'h1'}
                fontSize={12}
                fontWeight={500}
                display="flex"
                color="text.secondary"
              >
                Click on the
              </Typography>
              <Box
                mx={0.25}
                display={'flex'}
                justifyContent={'center'}
                component={'span'}
                sx={{color: 'primary.main'}}
                className="save-icon"
              >
                {<FaRegStar />}
              </Box>
              <Typography
                component={'h1'}
                fontSize={12}
                fontWeight={500}
                display="flex"
                color="text.secondary"
              >
                icon to Save a Job.
              </Typography>
            </Box>
            <Button
              sx={{
                background: '#000',
                mt: {xxs: 1, md: 2},
                px: 2,
                py: 1,
                height: 'fit-content',
                backgroundColor: 'secondary.main',
              }}
              variant="contained"
              size="16px"
              onClick={() => {
                openUrl('/jobfeed', '_self');
              }}
            >
              {'My Jobfeed'}
            </Button>
          </Box>
        </Box>
      :
      <Box 
        height={'80vh'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
      >
        <Typography sx={{fontSize: {xxs:'20px',md:'24px'}, fontWeight: 600, color: '#212529', mt: 3}}> 
          You Don't have Saved Jobs 
        </Typography>
        <Box sx={{mt: 3}}>
          <Image src={"https://job-static.hirist.com/V8/static/media/no-jobfeed.7771e408.svg"} alt="NoJobSaved" width={isLarge?457:229} height={isLarge?398:200} />
        </Box>
      </Box>
    
  );
};

export default NoJobsSaved;
